import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'smartDateFormat',
  standalone: true,
})
export class SmartDateFormatPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: Date, format: string, relativeDaysThreshold = 7): string {
    const date = new Date(value);
    const startOfDay = (d: Date): Date => {
      const copy = new Date(d);
      copy.setHours(0, 0, 0, 0);
      return copy;
    };

    const todayStart = startOfDay(new Date());
    const dateStart = startOfDay(date);
    const dayDiff = Math.round((todayStart.getTime() - dateStart.getTime()) / (24 * 60 * 60 * 1000));

    if (dayDiff === 0) {
      return this.translocoService.translate('translations.global.calendar.today');
    } else if (dayDiff === 1) {
      return this.translocoService.translate('translations.global.calendar.yesterday');
    } else if (dayDiff > 1 && dayDiff <= relativeDaysThreshold) {
      return this.translocoService.translate('translations.time.day.other', { count: dayDiff });
    } else {
      return new DatePipe('en-US').transform(value, format);
    }
  }
}
